import React, {useEffect, useRef} from 'react';
import ModalProgress from "../common/ModalProgress";
import {useState} from "react";
import {PermissionUtil} from "../../utils/PermissionUtil";
import ReactSelect from "../common/ReactSelect";
import {CommonUtil} from "../../utils/CommonUtil";

import Modal from "react-responsive-modal";
import ServicesSelector from "../services/ServicesSelector";
import ChatFlowsSelector from "../chatflows/ChatFlowsSelector";
import Axios from "axios";
import {API, BASE_URL} from "../../api/APIClient";
import {PluginSetupExplain, PluginSetupExplainActions} from "./PluginSetupExplain";
import {PluginUtil} from "../../utils/PluginUtil";
import {PluginChatFlowListBuilder} from "./PluginChatFlowListBuilder";

import {PluginSupportSelector} from "./PluginSupportSelector";
import {SectionType} from "../../constants/SectionType";
import axios from "axios";
import {PluginFormNavigationPreview} from "./PluginFormNavigationPreview";
import FileInput from "../common/FileInput";
import {UploadType} from "../../utils/UploadType";

import iconCharley from "../../assets/img/plugin/charley_wave_full.svg";
import iconBack from "../../assets/img/plugin/ic_back.svg";
import defaultAssistantOptionIcon from "../../assets/img/plugin/ic_charley_chat.svg";

import "../../uwbp.css";
import "../../plugin-cms.css";
import {NotificationManager} from "react-notifications";
import {ContextUtil} from "../../utils/ContextUtil";
import {ColourPicker} from "../common/ColourPicker";

export const PluginForm = (props) => {

    const MODAL_MODE_NONE = -1;
    const MODAL_MODE_CHAT_FLOW = 1;
    const MODAL_MODE_SERVICE = 2;
    const MODAL_MODE_CHAT_FLOW_LIST = 3;
    const MODAL_MODE_SUPPORT = 5;
    const MODAL_MODE_WELCOME_CHAT_FLOW_LIST = 6;
    const MODAL_MODE_CANVAS_INSTRUCTIONS = 7;
    const MODAL_MODE_CANVAS_LTI_JSON = 8;

    const {pluginId} = props;
    const {callback} = props;

    const [plugin, setPlugin] = useState();
    const [cmsConfig, setCmsConfig] = useState({});

    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingOrganisations, setIsLoadingOrganisations] = useState(false);
    const [isLoadingUserRoles, setIsLoadingUserRoles] = useState(false);
    const [isLoadingLocations, setIsLoadingLocations] = useState(false);

    const [isUploading, setIsUploading] = useState(false);
    const [organisationOptions, setOrganisationOptions] = useState();
    const [userRoleOptions, setUserRoleOptions] = useState([]);
    const [locationOptions, setLocationOptions] = useState([]);

    const [widgetGraphicFile, setWidgetGraphicFile] = useState(undefined);
    const [widgetGraphicData, setWidgetGraphicData] = useState(undefined);

    const [appBackgroundFile, setAppBackgroundFile] = useState(undefined);
    const [appBackgroundGraphicData, setAppBackgroundGraphicData] = useState(undefined);

    const [appStartBackgroundFile, setAppStartBackgroundFile] = useState(undefined);
    const [appStartBackgroundGraphicData, setAppStartBackgroundGraphicData] = useState(undefined);

    const [startScreenImageFile, setStartScreenImageFile] = useState(undefined);
    const [startScreenGraphicData, setStartScreenGraphicData] = useState(undefined);

    const [assistantOptionIconFile, setAssistantOptionIconFile] = useState(undefined);
    const [assistantOptionIconData, setAssistantOptionIconData] = useState(undefined);

    const [chatStartImageFile, setChatStartImageFile] = useState(undefined);
    const [chatStartImageData, setChatStartImageData] = useState(undefined);
    const [canvasIconFile, setCanvasIconFile] = useState(undefined);
    const [canvasIconData, setCanvasIconData] = useState(undefined);

    const [formData, setFormData] = useState({});
    const [touched, setTouched] = useState({});
    const [errors, setErrors] = useState({});

    const [colourPickerShown, setColourPickerShown] = useState(-1);

    const [modalOpen, setModalOpen] = useState(false);
    const [modalMode, setModalMode] = useState(MODAL_MODE_NONE);
    const modalMetadata = useRef({});

    const [notifConfigOptions, setNotifConfigOptions] = useState([]);
    const [isLoadingNotifConfigs, setIsLoadingNotifConfigs] = useState(false);
    const [ltiConfigJson, setLtiConfigJson] = useState("");
    const [isLoadingLtiConfig, setIsLoadingLtiConfig] = useState(false);
    const savedFormSnapshotRef = useRef("{}");

    const canvasPlacementOptions = [
        {value: "global_navigation", label: "Global Navigation"},
        {value: "course_navigation", label: "Course Navigation"},
        {value: "account_navigation", label: "Account Navigation"},
        {value: "user_navigation", label: "User Navigation"}
    ];

    useEffect(() => {
        getCMSConfigFromNetwork();

        if (pluginId) {
            fetchPluginConfigFromNetwork();
        }

        if (PermissionUtil.allOrgs("adminUser")) {
            fetchOrganisationsOverNetwork();
        }

        fetchUserRolesFromNetwork();
        if (!pluginId || !PermissionUtil.allOrgs("plugin")) {
            fetchCampusesFromNetwork();
        }
    }, []);

    useEffect(() => {
        if (plugin) {
            let organisationID = CommonUtil.getOrDefault(plugin, "organisationID");
            if (!organisationID) {
                organisationID = ContextUtil.getUser().organisationID;
            }

            const newFormData = {
                id : plugin.pluginId,
                name : plugin.name,
                notificationConfigID: plugin.notificationConfigID,
                organisationID: plugin.organisationID
            };

            const metadata = JSON.parse(plugin.data);
            const keys = Object.keys(metadata);
            keys.forEach((key) => {
                newFormData[key] = metadata[key];
            });
            setFormData(newFormData);
            savedFormSnapshotRef.current = getFormDataSnapshot(newFormData);

            fetchUserRolesFromNetwork();
            fetchCampusesFromNetwork(organisationID);
        }
    }, [plugin]);

    useEffect(() => {
        const organisationID = CommonUtil.getOrDefault(formData, "organisationID");
        if (organisationID) {
            fetchNotifConfigsFromNetwork(organisationID);
        }
    }, [formData.organisationID]);

    function fetchNotifConfigsFromNetwork(organisationID) {
        if (!organisationID || isLoadingNotifConfigs) return;
        setIsLoadingNotifConfigs(true);

        Axios.get(API.notificationProvider.getConfigs, {
            params: { organisationID }
        })
            .then((r) => {
                const resp = API.parse(r);
                if (resp.success) {
                    const configs = resp.data.configs || [];
                    const options = configs.map((config) => {
                        return {
                            value: config.id.toString(),
                            label: config.name || `Config ${config.id}`
                        };
                    });
                    setNotifConfigOptions(options);
                } else {
                    console.log(API.formatError(resp));
                }
                setIsLoadingNotifConfigs(false);
            })
            .catch((e) => {
                console.log(e);
                setIsLoadingNotifConfigs(false);
            });
    }

    function handleCallback(action, data) {
        if (callback) {
            callback(action, data);
        }
    }

    function handleSubmit(e) {
        e.preventDefault();
        e.stopPropagation();

        if (validateForm()) {
            submitPluginConfigOverNetwork();
        }
    }

    function validateForm() {
        let out = true;
        const errors = {};

        const requiredFields = [
            { "key" : "name", "label" : "Name" },
            { "key" : "chatFlowID", "label" : "Default Chat Flow" },
            // { "key" : "sosServiceID", "label" : "SOS Service" }
        ];

        for (let i = 0; i < requiredFields.length; i++) {
            let problem = false;

            const field = requiredFields[i];
            if (formData.hasOwnProperty(field.key)) {
                if (formData[field.key] === undefined || formData[field.key] === null) {
                    problem = true;
                }
            } else {
                problem = true;
            }

            if (problem) {
                out = false;
                errors[field.key] = "Please provide value for '" + field.label + "'";
            }
        }

        return out;
    }

    function getFormDataSnapshot(data) {
        return JSON.stringify(data || {});
    }

    function getPublicAssetUrl(url) {
        if (!url) {
            return null;
        }

        if (url.indexOf("://") !== -1) {
            return url;
        }

        return BASE_URL + "/" + url.replace(/^\/+/, "");
    }

    function normaliseImagePathForConfig(value) {
        if (!value) {
            return value;
        }

        if (value.indexOf("://") === -1) {
            return value.replace(/^\/+/, "");
        }

        try {
            const parsed = new URL(value);
            let path = (parsed.pathname || "").replace(/^\/+/, "");
            path = path.replace(/^v\d+\//, "");
            return path;
        } catch (e) {
            return value;
        }
    }

    function getApiOrigin() {
        try {
            if (BASE_URL && BASE_URL.indexOf("://") !== -1) {
                return new URL(BASE_URL).origin;
            }
        } catch (e) {}

        return window.location.origin;
    }

    function handleBlur(event) {
        const name = event.target.name;
        const newTouched = CommonUtil.cloneObject(touched);
        newTouched[name] = true;
        setTouched(touched);
    }

    function handleChange(event) {
        let value = event.target.type === "checkbox" ? (event.target.checked ? 1 : 0) : event.target.value;

        if (event.target.name === PluginUtil.configKeys.WIDGET_EMBED_TYPE) {
            if (event.target.checked) {
                value = PluginUtil.embedTypes.FLOATING;
            } else {
                value = PluginUtil.embedTypes.STATIC;
            }
        }

        let outData = {};
        outData[event.target.name] = value;
        putFormData(outData);
    }

    function handleColourChange(name, colour) {
        const value = colour.hex;

        let outData = {};
        outData[name] = value;
        putFormData(outData);
    }

    function putFormData(data) {
        if (!CommonUtil.isObject(data)) {
            return;
        }

        const newFormData = CommonUtil.cloneObject(formData);
        const keys = Object.keys(data);

        keys.forEach((key) => {
            const newData = data[key];
            if (newData !== undefined) {
                newFormData[key] = data[key];
            } else {
                delete newFormData[key];
            }
        });

        setFormData(newFormData);

        if (data.hasOwnProperty("organisationID")) {
            fetchCampusesFromNetwork(data.organisationID);
        }
    }

    function colourPickerDidCallback(action, data) {
        if (action === "focus") {
            setColourPickerShown(data);
        } else if (action === "blur") {
            setColourPickerShown(null);
        } else if (action === "change") {
            handleColourChange(data.name, data.color);
        }
    }

    function pluginModalDidDismiss() {
        setModalOpen(false);
    }

    function showPluginModal(mode, metadata) {
        modalMetadata.current = metadata;
        setModalMode(mode);
        setModalOpen(true);
    }

    function chatFlowWasRequested() {
        showPluginModal(MODAL_MODE_CHAT_FLOW, {});
    }

    function serviceWasRequested(prefix) {
        showPluginModal(MODAL_MODE_SERVICE, { prefix });
    }

    function isServiceSupported(serviceTypeID) {
        return PluginUtil.serviceTypesSupported.includes(parseInt(serviceTypeID));
    }

    function chatFlowListWasRequested(mode) {
        setModalMode(mode);
        setModalOpen(true);
    }

    function canvasInstructionsWasRequested() {
        if (!plugin || !plugin.identifier) {
            NotificationManager.warning("Please save the plugin configuration first.");
            return;
        }

        showPluginModal(MODAL_MODE_CANVAS_INSTRUCTIONS, {});
    }

    function canvasLtiJsonWasRequested() {
        if (!plugin || !plugin.identifier) {
            NotificationManager.warning("Please save the plugin configuration first.");
            return;
        }

        if (isFormDirty) {
            NotificationManager.warning("Please save the plugin configuration first before viewing LTI JSON.");
            return;
        }

        fetchCanvasLtiConfigFromNetwork(plugin.identifier);
    }

    function supportItemWasRequested(typeId, key) {
        modalMetadata.current = { typeId, key };
        setModalMode(MODAL_MODE_SUPPORT);
        setModalOpen(true);
    }

    function supportTableDidCallback(action, data) {
        if (action === "click") {
            setModalOpen(false);
            setModalMode(-1);

            if (modalMetadata.current) {
                const out = {};
                out[modalMetadata.current.key + "ID"] = data.id;
                out[modalMetadata.current.key + "Title"] = data.name;

                putFormData(out);
            }
        } else if (action === "dismiss") {
            setModalOpen(false);
            setModalMode(-1);
        }
    }

    function handleFilePickerChange(e, type) {
        e.preventDefault();

        if (e.target.files.length > 0) {
            const reader = new FileReader();
            const file = e.target.files[0];

            if (file) {
                reader.onloadend = () => {
                    if (type === "widget") {
                        setWidgetGraphicFile(file);
                        setWidgetGraphicData(reader.result);
                    } else if (type === "appBackground") {
                        setAppBackgroundFile(file);
                        setAppBackgroundGraphicData(reader.result);
                    } else if (type === "appStartBackground") {
                        setAppStartBackgroundFile(file);
                        setAppStartBackgroundGraphicData(reader.result);
                    } else if (type === "startScreenImage") {
                        setStartScreenImageFile(file);
                        setStartScreenGraphicData(reader.result);
                    } else if (type === "assistantOptionIcon") {
                        setAssistantOptionIconFile(file);
                        setAssistantOptionIconData(reader.result);
                    } else if (type === "chatStartImage") {
                        setChatStartImageFile(file);
                        setChatStartImageData(reader.result);
                    } else if (type === "canvasIcon") {
                        setCanvasIconFile(file);
                        setCanvasIconData(reader.result);
                    }
                }

                reader.readAsDataURL(file);
            }
        }
    }

    function handleFileDelete(type) {
        if (type === "widget") {
            setWidgetGraphicFile(undefined);
            setWidgetGraphicData(undefined);
        }
    }

    // NETWORK

    function fetchOrganisationsOverNetwork() {
        if (isLoadingOrganisations) return;
        setIsLoadingOrganisations(true);

        Axios.get(API.organisation.getOrganisations, {
            props : {
                appUsersOnly : 1
            }
        })
        .then((r) => {
            const resp = API.parse(r);
            if (resp.success) {
                const organisations = resp.data.organisations;
                if (organisations) {
                    const orgOptions = organisations.map((org) => {
                        return {
                            value : org.id.toString(),
                            label : org.name
                        }
                    });
                    setOrganisationOptions(orgOptions);
                }
            } else {
                console.log(API.formatError(resp));
            }
            setIsLoadingOrganisations(false);
        })
        .catch((e) => {
            console.log(e);
            setIsLoadingOrganisations(false);
        });
    }

    function fetchPluginConfigFromNetwork() {
        if (isLoading) return;
        setIsLoading(true);

        const data = {
            pluginConfigId : pluginId
        };

        Axios.post(API.plugin.getPluginConfig, data)
            .then((r) => {
                const resp = API.parse(r);
                if (resp.success) {
                    if (resp.data) {
                        if (resp.data.pluginConfig) {
                            setPlugin(resp.data.pluginConfig);
                        }
                    }
                } else {
                    console.log(API.formatError(r));
                }
                setIsLoading(false);
            })
            .catch((e) => {
                console.log(e);
                setIsLoading(false);
            });
    }

    function submitPluginConfigOverNetwork(bypassImageUpload, inData) {
        if (isLoading) return;
        setIsLoading(true);

        const data = inData ? inData : CommonUtil.cloneObject(formData);
        if (data.hasOwnProperty(PluginUtil.configKeys.CANVAS_ICON_IMAGE_URL)) {
            data[PluginUtil.configKeys.CANVAS_ICON_IMAGE_URL] = normaliseImagePathForConfig(data[PluginUtil.configKeys.CANVAS_ICON_IMAGE_URL]);
        }
        if (formData.id) {
            data.id = formData.id;
        } else if (plugin && plugin.pluginId) {
            data.id = formData.pluginId;
        } else if (pluginId) {
            data.pluginId = pluginId;
        }

        if (bypassImageUpload === undefined) {
            bypassImageUpload = false;
        }

        if (!bypassImageUpload) {
            // Determine if we have any images to upload
            const uploadImages = [];
            if (widgetGraphicFile) {
                uploadImages.push({
                    type: UploadType.PLUGIN_ASSISTANT_WIDGET_IMAGE,
                    file: widgetGraphicFile,
                    dataKeyID : PluginUtil.configKeys.WIDGET_ASSISTANT_IMAGE_ID,
                    dataKeyUrl : PluginUtil.configKeys.WIDGET_ASSISTANT_IMAGE_URL
                });
            }

            if (appBackgroundFile) {
                uploadImages.push({
                    type : UploadType.PLUGIN_ASSISTANT_BACKGROUND_IMAGE,
                    file : appBackgroundFile,
                    dataKeyID : PluginUtil.configKeys.APP_BACKGROUND_IMAGE_ID,
                    dataKeyUrl : PluginUtil.configKeys.APP_BACKGROUND_IMAGE_URL
                });
            }

            if (appStartBackgroundFile) {
                uploadImages.push({
                    type : UploadType.PLUGIN_ASSISTANT_CHAT_START_BACKGROUND,
                    file : appStartBackgroundFile,
                    dataKeyID : PluginUtil.configKeys.APP_START_BACKGROUND_IMAGE_ID,
                    dataKeyUrl : PluginUtil.configKeys.APP_START_BACKGROUND_IMAGE_URL
                });
            }

            if (startScreenImageFile) {
                uploadImages.push({
                    type : UploadType.PLUGIN_ASSISTANT_START_IMAGE,
                    file : startScreenImageFile,
                    dataKeyID : PluginUtil.configKeys.START_SCREEN_IMAGE_ID,
                    dataKeyUrl : PluginUtil.configKeys.START_SCREEN_IMAGE_URL
                });
            }

            if (assistantOptionIconFile) {
                uploadImages.push({
                    type : UploadType.PLUGIN_ASSISTANT_OPTION_ICON_IMAGE,
                    file : assistantOptionIconFile,
                    dataKeyID : PluginUtil.configKeys.CHAT_ASSISTANT_OPTION_IMAGE_ID,
                    dataKeyUrl : PluginUtil.configKeys.CHAT_ASSISTANT_OPTION_IMAGE_URL
                });
            }

            if (chatStartImageFile) {
                uploadImages.push({
                    type : UploadType.PLUGIN_ASSISTANT_CHAT_START_IMAGE,
                    file : chatStartImageFile,
                    dataKeyID : PluginUtil.configKeys.CHAT_START_IMAGE_ID,
                    dataKeyUrl : PluginUtil.configKeys.CHAT_START_IMAGE_URL
                });
            }

            if (canvasIconFile) {
                uploadImages.push({
                    type : UploadType.PLUGIN_ASSISTANT_OPTION_ICON_IMAGE,
                    file : canvasIconFile,
                    dataKeyID : PluginUtil.configKeys.CANVAS_ICON_IMAGE_ID,
                    dataKeyUrl : PluginUtil.configKeys.CANVAS_ICON_IMAGE_URL
                });
            }

            if (uploadImages.length > 0) {
                let uploadIndex = 0;

                const uploadCallback = (success, inData) => {
                    uploadIndex++;
                    if (uploadIndex >= uploadImages.length) {
                        // Images are uploaded, remove file references
                        setWidgetGraphicFile(undefined);
                        setAppBackgroundFile(undefined);
                        setStartScreenImageFile(undefined);
                        setAssistantOptionIconFile(undefined);
                        setChatStartImageFile(undefined);
                        setAppStartBackgroundFile(undefined);
                        setCanvasIconFile(undefined);

                        // And now call the submit function but with the bypass flag set
                        submitPluginConfigOverNetwork(true, inData);
                        return;
                    }

                    uploadImageOverNetwork(uploadImages[uploadIndex], uploadCallback, inData);
                };

                uploadImageOverNetwork(uploadImages[0], uploadCallback, data);
                return;
            }
        }

        Axios.post(API.plugin.submitPlugin, data)
            .then((r) => {
                const resp = API.parse(r);
                if (resp.success) {
                    setPlugin(resp.data.pluginConfig);
                    onSubmissionCompleted();
                } else {
                    console.log(API.formatError(r));

                    NotificationManager.error(API.formatError(r));

                    setIsLoading(false);
                }
            })
            .catch((e) => {
                console.log(e);
                setIsLoading(false);
            });
    }

    function uploadImageOverNetwork(data, callback, pluginData) {
        setIsLoading(true);

        console.log("Upload image: ", data);

        const formData = new FormData();
        formData.append("typeID", data.type);
        formData.append("file", data.file);

        Axios.post(API.image.uploadImage, formData)
            .then((r) => {
                const resp = API.parse(r);
                if (resp.success) {
                    pluginData[data.dataKeyID] = resp.data.imageID;
                    pluginData[data.dataKeyUrl] = resp.data.imageURL;

                    callback(true, pluginData);
                } else {
                    console.log(API.formatError(resp));
                    callback(false);
                }
            })
            .catch((e) => {
                console.log(e);
                callback(false);
            });
    }

    function onSubmissionCompleted() {
        setIsLoading(false);

        NotificationManager.success("Plugin Configuration has been saved");
    }

    function fetchCanvasLtiConfigFromNetwork(configId) {
        if (isLoadingLtiConfig) return;

        setIsLoadingLtiConfig(true);

        Axios.get(BASE_URL + "/v2/api/lti/config", {
            params: {
                configId
            }
        })
            .then((r) => {
                setLtiConfigJson(JSON.stringify(r.data, null, 2));
                showPluginModal(MODAL_MODE_CANVAS_LTI_JSON, {});
                setIsLoadingLtiConfig(false);
            })
            .catch((e) => {
                const apiError = e?.response?.data?.error;
                if (apiError && apiError.desc) {
                    NotificationManager.error(API.formatError(e.response));
                } else {
                    NotificationManager.error("Could not load Canvas LTI JSON config.");
                }
                setIsLoadingLtiConfig(false);
            });
    }

    function copyCanvasLtiJson() {
        if (!ltiConfigJson) {
            return;
        }

        navigator.clipboard.writeText(ltiConfigJson)
            .then(() => {
                NotificationManager.success("LTI JSON copied.");
            })
            .catch(() => {
                NotificationManager.error("Could not copy LTI JSON.");
            });
    }

    function fetchUserRolesFromNetwork() {
        if (isLoadingUserRoles) return;
        setIsLoadingUserRoles(true);

        Axios.get(API.appUser.getRoleOptions)
            .then((r) => {
                const resp = API.parse(r);
                if (resp.success) {
                    const options = resp.data.roleOptions.map((role) => {
                        return {
                            value: role.id.toString(),
                            label: role.name
                        };
                    })
                    setUserRoleOptions(options);
                } else {
                    console.log(API.formatError(resp));
                }

                setIsLoadingUserRoles(false);
            })
            .catch((e) => {
                console.log(e);
                setIsLoadingUserRoles(false);
            });
    }

    function fetchCampusesFromNetwork(organisationID) {
        if (!organisationID) {
            organisationID = CommonUtil.getOrDefault(formData, "organisationID");
        }

        if (!organisationID) {
            organisationID = ContextUtil.getUser().organisationID;
        }

        if (!organisationID || isLoadingLocations) return;
        setIsLoadingLocations(true);

        Axios.get(API.campus.getCampuses, {params: {organisationID}})
            .then((r) => {
                const resp = API.parse(r);
                if (resp.success) {
                    const locations = resp.data.campusOptions.map((campus) => {
                        return {
                            value: campus.id.toString(),
                            label: campus.name
                        };
                    })
                    setLocationOptions(locations);
                } else {
                    console.log(API.formatError(resp));
                }
                setIsLoadingLocations(false);
            })
            .catch((e) => {
                console.log(e);
                setIsLoadingLocations(false);
            });
    }

    function getCMSConfigFromNetwork() {
        axios.get(API.plugin.getCmsConfig)
            .then((r) => {
                const resp = API.parse(r);
                if (resp.success) {
                    setCmsConfig(resp.data);
                } else {
                    console.log(API.formatError(r));
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    // RENDER
    let modalTitle = "New Configuration";
    if (pluginId) {
        modalTitle = "Edit Configuration";
    }
    const isFormDirty = getFormDataSnapshot(formData) !== savedFormSnapshotRef.current;

    let organisationPicker = [];
    if (PermissionUtil.allOrgs("plugin")) {
        organisationPicker = <div className="grid-x grid-padding-x">
            <div className="small-3 cell">
                <label htmlFor="organisationID" className="text-right middle">* Created By</label>
            </div>
            <div className={"small-9 cell " + (CommonUtil.getOrDefault(errors, "organisationID", null) && "error")}>
                <ReactSelect
                    name="organisationID"
                    className="react-select"
                    onChange={handleChange}
                    value={CommonUtil.getOrDefault(formData, "organisationID", null)}
                    options={organisationOptions}
                    onBlur={handleBlur}
                />
                <small className="error">{CommonUtil.getOrDefault(errors, "organisationID", "")}</small>
            </div>
        </div>
    }

    let modalContent = [];
    if (modalMode === MODAL_MODE_CHAT_FLOW) {
        let chatFlowID = CommonUtil.getOrDefault("formData", "chatFlowID", null);
        let selectedValue = [];
        if (chatFlowID !== null) {
            selectedValue.push(chatFlowID);
        }

        modalContent = (
            <ChatFlowsSelector
                isSingleSelection
                onCancel={() => setModalOpen(false)}
                pluginCompatible={1}
                selected={selectedValue}
                onSubmitted={(chatFlow) => {
                    if (chatFlow) {
                        const outData = {
                            chatFlowID : chatFlow.id,
                            chatFlowTitle : chatFlow.title,
                            chatFlowCompatibility : chatFlow.pluginCompatible
                        };
                        putFormData(outData);
                    }
                    setModalOpen(false);
                }}
                onClose={() => {
                    setModalOpen(false);
                }}/>
        );
    } else if (modalMode === MODAL_MODE_SERVICE) {
        modalContent = (
            <ServicesSelector
                isSingleSelection
                serviceTypes={PluginUtil.serviceTypesSupported}
                onCancel={() => setModalOpen(false)}
                onSubmitted={(service) => {
                    if (modalMetadata.current && service) {
                        let keyPrefix = "";
                        if (modalMetadata.current.hasOwnProperty("prefix")) {
                            keyPrefix = modalMetadata.current.prefix;
                        }
                        const outData = {}
                        outData[keyPrefix + "ID"] = service.id;
                        outData[keyPrefix + "Title"] = service.title;
                        outData[keyPrefix + "TypeID"] = service.typeID;
                        putFormData(outData);
                    }
                    setModalOpen(false)
                }}
            />
        );
    } else if (modalMode === MODAL_MODE_CHAT_FLOW_LIST || modalMode === MODAL_MODE_WELCOME_CHAT_FLOW_LIST) {
        modalContent = (
            <PluginChatFlowListBuilder
                data={CommonUtil.getOrDefault(formData, modalMode === MODAL_MODE_CHAT_FLOW_LIST ? "chatFlows" : "welcomeChatFlows", [])}
                callback={(action, data) => {
                    if (action === "submit") {

                        if (modalMode === MODAL_MODE_CHAT_FLOW_LIST) {
                            putFormData({
                                chatFlows : JSON.stringify(data)
                            });
                        }
                        else {
                            putFormData({
                                welcomeChatFlows : JSON.stringify(data)
                            });
                        }

                        setModalOpen(false);
                        setModalMode(-1);
                    } else if (action === "cancel") {
                        setModalOpen(false);
                        setModalMode(-1);
                    }
                }} />
        )
    } else if (modalMode === MODAL_MODE_SUPPORT) {
        modalContent = (
            <PluginSupportSelector
                sectionType={modalMetadata.current.typeId}
                callback={supportTableDidCallback} />
        );
    } else if (modalMode === MODAL_MODE_CANVAS_INSTRUCTIONS) {
        modalContent = (
            <div style={{padding: "16px"}}>
                <h4>Canvas setup steps</h4>
                <ol>
                    <li>Log in to Canvas as an admin user (required to manage Developer Keys and external apps).</li>
                    <li>Go to Admin &gt; Developer Keys, then create or edit a key of type <strong>LTI Key</strong>.</li>
                    <li>Choose one configuration method:
                        <ul>
                            <li>Use dynamic config URL:<br/><code>{getApiOrigin() + "/v2/api/lti/config?configId=" + (plugin?.identifier ?? "YOUR_CONFIG_ID")}</code></li>
                            <li>Or copy/paste JSON from the <strong>Show LTI JSON config</strong> button in this screen.</li>
                        </ul>
                    </li>
                    <li>Save and enable the key, then copy the generated client ID.</li>
                    <li>Install/configure the app in your course or account using that enabled key.</li>
                    <li>After installation, open the app settings in Canvas and copy the <strong>Deployment ID</strong> from the installed tool details page.</li>
                    <li>Canvas platform values for <strong>LTI Platform Details</strong>:
                        <ul>
                            <li><strong>Issuer</strong>: your Canvas base URL (eg. <code>https://canvas.uni.com</code>).</li>
                            <li><strong>JWKS URI</strong>: <code>https://YOUR_CANVAS_DOMAIN/api/lti/security/jwks</code></li>
                            <li><strong>Auth Login URI</strong>: <code>https://YOUR_CANVAS_DOMAIN/api/lti/authorize_redirect</code></li>
                            <li><strong>Token URI</strong> (optional): <code>https://YOUR_CANVAS_DOMAIN/login/oauth2/token</code> (used for LTI Advantage service API calls).</li>
                        </ul>
                    </li>
                    <li>In app placements, ensure at least one selected placement is enabled.</li>
                    <li>If placement/settings change later, re-sync the app in Canvas to pull updated config.</li>
                </ol>
            </div>
        );
    } else if (modalMode === MODAL_MODE_CANVAS_LTI_JSON) {
        modalContent = (
            <div style={{padding: "16px"}}>
                <h4>Canvas LTI JSON Config</h4>
                <textarea
                    readOnly
                    style={{minHeight: "340px", fontFamily: "monospace"}}
                    value={ltiConfigJson}
                />
                <div className="btn-wrap" style={{marginTop: "10px"}}>
                    <button type="button" className="button" onClick={copyCanvasLtiJson}>Copy JSON</button>
                </div>
            </div>
        );
    }

    let sosServiceWarningElem = [];
    // if (CommonUtil.getOrDefault(formData, "sosServiceID") && !isServiceSupported(CommonUtil.getOrDefault(formData, "sosServiceTypeID", -1))) {
    //     sosServiceWarningElem = (
    //         <div className={"alert alert-warning"}>This Service is not supported in the Plugin.</div>
    //     );
    // }

    let menuServiceWarningElem = [];
    // if (CommonUtil.getOrDefault(formData, "menuServiceID") && !isServiceSupported(CommonUtil.getOrDefault(formData, "menuServiceTypeID", -1))) {
    //     menuServiceWarningElem = (
    //         <div className={"alert alert-warning"}>This Service is not supported in the Plugin.</div>
    //     )
    // }

    let integrationExplainElem = (
        <div className="grid-x grid-padding-x" style={{marginBottom: "10px"}}>
            <div className={"small-12 cell"} style={{textAlign : "center", fontStyle : "italic"}}>
                <p>Please save this Configuration to see how to integrate the Plugin into your website.</p>
            </div>
        </div>
    );
    if (plugin) {
        integrationExplainElem = (
            <>
                <div className="grid-x grid-padding-x" style={{marginBottom: "10px"}}>
                    <div className={"small-12 cell"}>
                    <p>Add the UniWellBeing Plugin to your website. Pick how you would like to add the Plugin to your
                            site:</p>
                    </div>
                </div>

                <div className="grid-x grid-padding-x" style={{marginBottom: "10px"}}>
                    <div className={"small-12 cell"}>

                        <PluginSetupExplain
                            configId={CommonUtil.getOrDefault(plugin, "identifier")}
                            formData={formData}
                            cmsConfig={cmsConfig}
                            callback={(action, data) => {
                                if (action === PluginSetupExplainActions.CHANGE_APP_HEADER) {
                                    let newData = {};
                                    newData[PluginUtil.configKeys.SHOW_APP_HEADER] = data;
                                    putFormData(newData);
                                }
                            }}
                        />

                    </div>
                </div>
            </>
        );
    }

    let defaultChatFlowWarningElem = [];
    if (parseInt(CommonUtil.getOrDefault(formData, "chatFlowCompatibility", -1)) === 0) {
        defaultChatFlowWarningElem = (
            <div className={"alert-message alert-warning"} style={{fontSize:"small"}}>This Chat Flow has not been marked as Plugin Compatible. It may contain incompatible functionality. Please review carefully.</div>
        );
    }

    let welcomeScreenChatOptions = (
        <div className="grid-x grid-padding-x">
            <div className="small-3 cell">
                <label htmlFor="welcomeChatFlows" className="text-right middle">Default Quick Chat Flows (optional)</label>
            </div>
            <div className={"large-9 small-9 cell"}>
                <div className="input-group">
                    <input
                        className="input-group-field"
                        name="welcomeChatFlows"
                        type="text"
                        value={JSON.parse(CommonUtil.getOrDefault(formData, "welcomeChatFlows", "[]")).length + " Chat Flows"}
                        disabled
                    />

                    <div className="input-group-button">
                        <button
                            type="button"
                            className="button"
                            onClick={() => chatFlowListWasRequested(MODAL_MODE_WELCOME_CHAT_FLOW_LIST)}
                        >
                            Browse
                        </button>
                    </div>
                </div>
                <small className="error"></small>
                {menuServiceWarningElem}
            </div>
        </div>
    );

    // HEADER CONFIG
    let headerConfigContent = [];
    let headerNavigationStyle = CommonUtil.getOrDefault(formData, PluginUtil.configKeys.CHAT_OPTIONS_MODE, PluginUtil.chatOptionsModes.SHOW_IN_HEADER);
    if (headerNavigationStyle !== PluginUtil.chatOptionsModes.NO_HEADER) {
        let sosOptions = [];
        if (CommonUtil.getOrDefault(formData, PluginUtil.configKeys.CHAT_SHOW_SOS, true)) {
            sosOptions = (
                <div className="grid-x grid-padding-x">
                    <div className="small-3 cell">
                        <label htmlFor="actionItem" className="text-right middle">I Need Help Section</label>
                    </div>
                    <div className={"large-9 small-9 cell"}>
                        <div className="input-group">
                            <input
                                className="input-group-field"
                                name="actionItem"
                                type="text"
                                value={CommonUtil.getOrDefault(formData, "sosServiceTitle", "Please select")}
                                disabled
                            />

                            <div className="input-group-button">
                                <button
                                    type="button"
                                    className="button"
                                    onClick={() => supportItemWasRequested(SectionType.ASSISTANT_NEED_HELP, "sosService")}
                                >
                                    Browse
                                </button>
                            </div>
                        </div>
                        <small className="error"></small>
                        {sosServiceWarningElem}
                    </div>
                </div>
            );
        }

        let chatOptions = [];
        if (CommonUtil.getOrDefault(formData, PluginUtil.configKeys.CHAT_SHOW_CHARLEY, true)) {
            chatOptions = (
                <div className="grid-x grid-padding-x">
                    <div className="small-3 cell">
                        <label htmlFor="actionItem" className="text-right middle">Available Chat Flows</label>
                    </div>
                    <div className={"large-9 small-9 cell"}>
                        <div className="input-group">
                            <input
                                className="input-group-field"
                                name="actionItem"
                                type="text"
                                value={JSON.parse(CommonUtil.getOrDefault(formData, "chatFlows", "[]")).length + " Chat Flows"}
                                disabled
                            />

                            <div className="input-group-button">
                                <button
                                    type="button"
                                    className="button"
                                    onClick={() => chatFlowListWasRequested(MODAL_MODE_CHAT_FLOW_LIST)}
                                >
                                    Browse
                                </button>
                            </div>
                        </div>
                        <small className="error"></small>
                        {menuServiceWarningElem}
                    </div>
                </div>
            );
        }

        let menuOptions = [];
        if (CommonUtil.getOrDefault(formData, PluginUtil.configKeys.CHAT_SHOW_OVERFLOW, true)) {
            menuOptions = (
                <div className="grid-x grid-padding-x">
                    <div className="small-3 cell">
                        <label htmlFor="actionItem" className="text-right middle">Explore Support Section</label>
                    </div>
                    <div className={"large-9 small-9 cell"}>
                        <div className="input-group">
                            <input
                                className="input-group-field"
                                name="actionItem"
                                type="text"
                                value={CommonUtil.getOrDefault(formData, "supportSectionTitle", "Please select")}
                                disabled
                            />

                            <div className="input-group-button">
                                <button
                                    type="button"
                                    className="button"
                                    onClick={() => supportItemWasRequested(SectionType.ASSISTANT_SUPPORT, "supportSection")}
                                >
                                    Browse
                                </button>
                            </div>
                        </div>
                        <small className="error"></small>
                        {menuServiceWarningElem}
                    </div>
                </div>
            );
        }

        headerConfigContent = (
            <>
                <ImagePickerField
                    label={"Assistant Option Icon"}
                    imageData={assistantOptionIconData ?? CommonUtil.getOrDefault(formData, PluginUtil.configKeys.CHAT_ASSISTANT_OPTION_IMAGE_URL, defaultAssistantOptionIcon)}
                    className={"plugin-form-image-preview-circular"}
                    callback={(action, data) => {
                        if (action === ImagePickerFieldActions.CHANGE) {
                            handleFilePickerChange(data, "assistantOptionIcon")
                        } else if (action === ImagePickerFieldActions.DELETE) {
                            setAssistantOptionIconFile(undefined);
                            setAssistantOptionIconData(undefined);

                            const formData = {};
                            formData[PluginUtil.configKeys.CHAT_ASSISTANT_OPTION_IMAGE_ID] = undefined;
                            formData[PluginUtil.configKeys.CHAT_ASSISTANT_OPTION_IMAGE_URL] = undefined;
                            putFormData(formData);
                        }
                    }}
                />

                <div className="grid-x grid-padding-x">
                    <div className="small-3 cell">
                        <label htmlFor={PluginUtil.configKeys.CHAT_SHOW_SOS} className="text-right middle">Show SOS button</label>
                    </div>
                    <div className="large-4 small-9 cell">
                        <label className="chkbx-container">
                            <input
                                className="chkbx"
                                type="checkbox"
                                name={PluginUtil.configKeys.CHAT_SHOW_SOS}
                                onChange={handleChange}
                                checked={CommonUtil.getOrDefault(formData, PluginUtil.configKeys.CHAT_SHOW_SOS, true)}
                            />

                            <span className="chkmk"></span>
                        </label>
                    </div>
                </div>

                {sosOptions}

                <div className="grid-x grid-padding-x">
                    <div className="small-3 cell">
                        <label htmlFor={PluginUtil.configKeys.CHAT_SHOW_OVERFLOW} className="text-right middle">
                            Show Explore button
                        </label>
                    </div>
                    <div className="large-4 small-9 cell">
                        <label className="chkbx-container">
                            <input
                                className="chkbx"
                                type="checkbox"
                                name={PluginUtil.configKeys.CHAT_SHOW_OVERFLOW}
                                onChange={handleChange}
                                checked={CommonUtil.getOrDefault(formData, PluginUtil.configKeys.CHAT_SHOW_OVERFLOW, true)}
                            />

                            <span className="chkmk"></span>
                        </label>
                    </div>
                </div>

                {menuOptions}

                <div className="grid-x grid-padding-x">
                    <div className="small-3 cell">
                        <label htmlFor={PluginUtil.configKeys.CHAT_SHOW_QR_LINK} className="text-right middle">
                            Show App Download link
                        </label>
                    </div>
                    <div className="large-4 small-9 cell">
                        <label className="chkbx-container">
                            <input
                                className="chkbx"
                                type="checkbox"
                                name={PluginUtil.configKeys.CHAT_SHOW_QR_LINK}
                                onChange={handleChange}
                                checked={CommonUtil.getOrDefault(formData, PluginUtil.configKeys.CHAT_SHOW_QR_LINK, true)}
                            />

                            <span className="chkmk"></span>
                        </label>
                    </div>
                </div>

                <div className="grid-x grid-padding-x">
                    <div className="small-3 cell">
                        <label htmlFor={PluginUtil.configKeys.CHAT_SHOW_CHARLEY} className="text-right middle">
                            Show Quick Chats
                        </label>
                    </div>
                    <div className="large-4 small-9 cell">
                        <label className="chkbx-container">
                            <input
                                className="chkbx"
                                type="checkbox"
                                name={PluginUtil.configKeys.CHAT_SHOW_CHARLEY}
                                onChange={handleChange}
                                checked={CommonUtil.getOrDefault(formData, PluginUtil.configKeys.CHAT_SHOW_CHARLEY, true)}
                            />

                            <span className="chkmk"></span>
                        </label>
                    </div>
                </div>

                {chatOptions}

            </>
        )
    }

    let poweredByContent = [];
    if (CommonUtil.getOrDefault(formData, PluginUtil.configKeys.POWERED_BY_ENABLED, true)) {
        poweredByContent = (
            <>
                <div className="grid-x grid-padding-x">
                    <div className="small-3 cell">
                        <label htmlFor="actionItem" className="text-right middle">Powered By Label</label>
                    </div>
                    <div className={"large-9 small-9 cell"}>
                        <div className="input-group">
                            <input
                                className="input-group-field"
                                name={PluginUtil.configKeys.POWERED_BY_LABEL}
                                type="text"
                                value={CommonUtil.getOrDefault(formData, PluginUtil.configKeys.POWERED_BY_LABEL, "")}
                                placeholder={"Powered by..."}
                                onChange={(e) => {
                                    const newData = {};
                                    newData[PluginUtil.configKeys.POWERED_BY_LABEL] = e.target.value;
                                    putFormData(newData);
                                }}
                            />
                        </div>
                        <small className="error"></small>
                    </div>
                </div>

                <div className="grid-x grid-padding-x">
                    <div className="small-3 cell">
                        <label htmlFor="actionItem" className="text-right middle">Powered By URL</label>
                    </div>
                    <div className={"large-9 small-9 cell"}>
                        <div className="input-group">
                            <input
                                className="input-group-field"
                                name={PluginUtil.configKeys.POWERED_BY_URL}
                                type="text"
                                value={CommonUtil.getOrDefault(formData, PluginUtil.configKeys.POWERED_BY_URL, "")}
                                placeholder={"https://studentxp.ai/"}
                                onChange={(e) => {
                                    const newData = {};
                                    newData[PluginUtil.configKeys.POWERED_BY_URL] = e.target.value;
                                    putFormData(newData);
                                }}
                            />
                        </div>
                        <small className="error"></small>
                    </div>
                </div>
            </>
        )
    }

    let assistantGraphicUploadElem = [];
    if (parseInt(CommonUtil.getOrDefault(formData, "widgetShowIcon", 1)) === 1) {
        let widgetGraphicRemoveButton = [];
        if (CommonUtil.getOrDefault(formData, PluginUtil.configKeys.WIDGET_ASSISTANT_IMAGE_URL, null)) {
            widgetGraphicRemoveButton = (
                <button className={"button danger"} onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();

                    const newData = {};
                    newData[PluginUtil.configKeys.WIDGET_ASSISTANT_IMAGE_ID] = undefined;
                    newData[PluginUtil.configKeys.WIDGET_ASSISTANT_IMAGE_URL] = undefined;
                    putFormData(newData);
                }}>
                    Restore to Default
                </button>
            );
        }

        assistantGraphicUploadElem = (
            <>

                <div className="grid-x grid-padding-x">
                    <div className="small-3 cell">
                        <label htmlFor="imageFile" className="text-right middle">Change Widget Image</label>
                    </div>
                    <div className="large-9 small-9 cell ">
                        <FileInput
                            name="file"
                            onChange={(e) => handleFilePickerChange(e, "widget")}
                            onDelete={() => handleFileDelete("widget")}
                            placeholder="Not selected."
                            accept="image/jpeg,image/jpg,image/png,image/svg,image/svg+xml"
                        />

                        {widgetGraphicRemoveButton}
                    </div>
                </div>

            </>
        )
    }



    let widgetEmbedPositionElem = [];
    if (parseInt(CommonUtil.getOrDefault(formData, PluginUtil.configKeys.WIDGET_EMBED_TYPE, 1)) === PluginUtil.embedTypes.FLOATING) {
        widgetEmbedPositionElem = (
            <div className="grid-x grid-padding-x">
                <div className="small-3 cell">
                    <label htmlFor="defaultUserRoleID" className="text-right middle">Floating Button Position</label>
                </div>
                <div className={"small-9 cell"}>
                    <ReactSelect
                        name={PluginUtil.configKeys.WIDGET_EMBED_POSITION}
                        className="react-select"
                        onChange={handleChange}
                        value={CommonUtil.getOrDefault(formData, PluginUtil.configKeys.WIDGET_EMBED_POSITION, PluginUtil.embedPositions.TOP_LEFT)}
                        options={[
                            {
                                value: PluginUtil.embedPositions.TOP_LEFT,
                                label: "Top Left"
                            },
                            {
                                value: PluginUtil.embedPositions.TOP_RIGHT,
                                label: "Top Right"
                            },
                            {
                                value: PluginUtil.embedPositions.BOTTOM_RIGHT,
                                label: "Bottom Right"
                            },
                            {
                                value: PluginUtil.embedPositions.BOTTOM_LEFT,
                                label: "Bottom Left"
                            },
                        ]}
                        onBlur={handleBlur}
                    />
                </div>
            </div>
        )
    }

    return (
        <>
            <ModalProgress show={isUploading}/>
            <div className={"modal-head"}>
                <div className={"modal-head"}>
                    <h3>{modalTitle}</h3>
                </div>
            </div>

            <form onSubmit={handleSubmit}>
                <div className={"modal-body"}>
                    {organisationPicker}

                    <div className="grid-x grid-padding-x">
                        <div className="small-3 cell">
                            <label htmlFor="name" className="text-right middle ">* Name</label>
                        </div>
                        <div className={"small-9 cell " + (CommonUtil.getOrDefault(errors, "name", null) && "error")}>
                            <input
                                type="text"
                                name="name"
                                onChange={handleChange}
                                value={CommonUtil.getOrDefault(formData, "name", "")}
                                onBlur={handleBlur}
                            />

                            <small className="error">{CommonUtil.getOrDefault(errors, "name", "")}</small>
                        </div>
                    </div>

                    <div className="grid-x grid-padding-x">
                        <div className="small-3 cell">
                            <label htmlFor="actionItem" className="text-right middle">Default Chat Flow</label>
                        </div>
                        <div className={"large-9 small-9 cell"}>
                            <div className="input-group">
                                <input
                                    className="input-group-field"
                                    name="actionItem"
                                    type="text"
                                    value={CommonUtil.getOrDefault(formData, "chatFlowTitle", "Please Select")}
                                    disabled
                                />

                                <div className="input-group-button">
                                    <button
                                        type="button"
                                        className="button"
                                        onClick={() => chatFlowWasRequested()}
                                    >
                                        Browse
                                    </button>
                                </div>
                            </div>

                            {defaultChatFlowWarningElem}

                            <small className="error"></small>
                        </div>
                    </div>

                    <div className="grid-x grid-padding-x">
                        <div className="small-12 cell">
                            <fieldset className="fieldset">
                                <legend>Privacy &amp; Authentication</legend>

                                <div className="grid-x grid-padding-x">
                                    <div className="small-3 cell">
                                        <label className="text-right middle">&nbsp;</label>
                                    </div>
                                    <div
                                        className={"small-9 cell " + (CommonUtil.getOrDefault(errors, "organisationID", null) && "error")}>

                                        <p>
                                            <strong>Important Information</strong><br/>
                                            If this Plugin Configuration is intended to be embedded in situations where
                                            there is an expectation of privacy, enabling User Persistence allows the
                                            user to pick up where they last left-off with the Assistant Plugin. This
                                            option should be used carefully.
                                        </p>

                                    </div>
                                </div>

                                <div className="grid-x grid-padding-x">
                                    <div className="small-3 cell">
                                        <label htmlFor={PluginUtil.configKeys.ALLOW_PERSISTENT_STORAGE}
                                               className="text-right middle">Enable User Persistence</label>
                                    </div>
                                    <div className="large-4 small-9 cell">
                                        <label className="chkbx-container">
                                            <input
                                                className="chkbx"
                                                type="checkbox"
                                                name={PluginUtil.configKeys.ALLOW_PERSISTENT_STORAGE}
                                                onChange={handleChange}
                                                checked={CommonUtil.getOrDefault(formData, PluginUtil.configKeys.ALLOW_PERSISTENT_STORAGE, false)}
                                            />

                                            <span className="chkmk"></span>
                                        </label>
                                    </div>
                                </div>

                                <div className="grid-x grid-padding-x">
                                    <div className="small-3 cell">
                                        <label htmlFor="defaultUserRoleID" className="text-right middle">&nbsp;</label>
                                    </div>
                                    <div
                                        className={"small-9 cell " + (CommonUtil.getOrDefault(errors, "organisationID", null) && "error")}>

                                        <p>
                                            <strong>Important Information</strong><br/>
                                            When a user cannot be otherwise identified, the Plugin will create a temporary User account using the following details.
                                        </p>

                                    </div>
                                </div>

                                <div className="grid-x grid-padding-x">
                                    <div className="small-3 cell">
                                        <label htmlFor="defaultUserRoleID" className="text-right middle">Default User
                                            Role</label>
                                    </div>
                                    <div
                                        className={"small-9 cell " + (CommonUtil.getOrDefault(errors, "organisationID", null) && "error")}>
                                        <ReactSelect
                                            name="defaultUserRoleID"
                                            className="react-select"
                                            onChange={handleChange}
                                            value={CommonUtil.getOrDefault(formData, "defaultUserRoleID", null)}
                                            options={userRoleOptions}
                                            onBlur={handleBlur}
                                        />
                                        <small className={"field-info"}>The default User Role assumed by the Plugin
                                            before the user provides their own User Role.</small>

                                        <small
                                            className="error">{CommonUtil.getOrDefault(errors, "defualtUserRoleID", "")}</small>
                                    </div>
                                </div>

                                <div className="grid-x grid-padding-x">
                                    <div className="small-3 cell">
                                        <label htmlFor="defaultLocationID" className="text-right middle">Default
                                            Campus</label>
                                    </div>
                                    <div
                                        className={"small-9 cell " + (CommonUtil.getOrDefault(errors, "defaultLocationID", null) && "error")}>
                                        <ReactSelect
                                            name="defaultLocationID"
                                            className="react-select"
                                            onChange={handleChange}
                                            value={CommonUtil.getOrDefault(formData, "defaultLocationID", null)}
                                            options={locationOptions}
                                            onBlur={handleBlur}
                                        />
                                        <small
                                            className="error">{CommonUtil.getOrDefault(errors, "defaultLocationID", "")}</small>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>

                    <div className="grid-x grid-padding-x">
                        <div className="small-12 cell">
                            <fieldset className="fieldset">
                                <legend>Widget Appearance</legend>

                                <div className="grid-x grid-padding-x">
                                    <div className={"small-12 cell"}>

                                        <div
                                            className={"uwbp-widget-container " + CommonUtil.getOrDefault(formData, "widgetAlignment", "left")}>
                                            <div className={"uwbp-widget"} style={{
                                                borderColor: CommonUtil.getOrDefault(formData, "widgetBorderColour"),
                                                backgroundColor: CommonUtil.getOrDefault(formData, "widgetBackgroundColour")
                                            }}>
                                                <div className={"uwbp-widget-content"}>
                                                    <div
                                                        className={"uwbp-widget-content-title"}
                                                        style={{color: CommonUtil.getOrDefault(formData, "widgetTextColour")}}
                                                    >
                                                        {CommonUtil.getStringOrDefault(formData, "widgetTitle", "Wellbeing Assistant")}
                                                    </div>
                                                    {CommonUtil.getOrDefault(formData, "widgetShowIcon", true) ?
                                                        <div className={"uwbp-widget-content-icon"}
                                                             style={{backgroundImage: "url(" + (widgetGraphicData ? widgetGraphicData : CommonUtil.getOrDefault(formData, PluginUtil.configKeys.WIDGET_ASSISTANT_IMAGE_URL, iconCharley)) + ")"}}/>
                                                        :
                                                        []
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <div className="grid-x grid-padding-x" style={{marginTop: "10px"}}>
                                    <div className="small-3 cell">
                                        <label htmlFor="name" className="text-right middle">Title</label>
                                    </div>
                                    <div className={"small-9 cell"}>
                                        <input
                                            type="text"
                                            name="widgetTitle"
                                            onChange={handleChange}
                                            value={CommonUtil.getOrDefault(formData, "widgetTitle", "")}
                                            placeholder={"Wellbeing Assistant"}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </div>

                                <div className="grid-x grid-padding-x">
                                    <div className="small-3 cell">
                                        <label htmlFor="showCharley" className="text-right middle">Show Charley</label>
                                    </div>
                                    <div className="large-4 small-9 cell">
                                        <label className="chkbx-container">
                                            <input
                                                className="chkbx"
                                                type="checkbox"
                                                name="widgetShowIcon"
                                                onChange={handleChange}
                                                checked={CommonUtil.getOrDefault(formData, "widgetShowIcon", true)}
                                            />

                                            <span className="chkmk"></span>
                                        </label>
                                    </div>
                                </div>

                                {assistantGraphicUploadElem}

                                <div className="grid-x grid-padding-x">
                                    <div className="small-3 cell">
                                        <label htmlFor="action" className="text-right middle">Border Colour</label>
                                    </div>
                                    <div className="large-4 small-9 cell">
                                        <ColourPicker
                                            shown={colourPickerShown === "widgetBorderColour"}
                                            name={"widgetBorderColour"}
                                            value={CommonUtil.getOrDefault(formData, "widgetBorderColour", "#000")}
                                            callback={colourPickerDidCallback}
                                        />
                                    </div>
                                </div>

                                <div className="grid-x grid-padding-x">
                                    <div className="small-3 cell">
                                        <label htmlFor="action" className="text-right middle">Background Colour</label>
                                    </div>
                                    <div className="large-4 small-9 cell">
                                        <ColourPicker
                                            shown={colourPickerShown === "widgetBackgroundColour"}
                                            name={"widgetBackgroundColour"}
                                            value={CommonUtil.getOrDefault(formData, "widgetBackgroundColour", "#FFF")}
                                            callback={colourPickerDidCallback}
                                        />
                                    </div>
                                </div>

                                <div className="grid-x grid-padding-x">
                                    <div className="small-3 cell">
                                        <label htmlFor="action" className="text-right middle">Text Colour</label>
                                    </div>
                                    <div className="large-4 small-9 cell">
                                        <ColourPicker
                                            shown={colourPickerShown === "widgetTextColour"}
                                            name={"widgetTextColour"}
                                            value={CommonUtil.getOrDefault(formData, "widgetTextColour", "#000")}
                                            callback={colourPickerDidCallback}
                                        />
                                    </div>
                                </div>

                                <div className="grid-x grid-padding-x">
                                    <div className="small-3 cell">
                                        <label htmlFor="widgetAlignment" className="text-right middle">Widget
                                            Alignment</label>
                                    </div>
                                    <div className="large-9 small-9 cell">
                                        <ReactSelect
                                            name="widgetAlignment"
                                            onChange={handleChange}
                                            value={CommonUtil.getOrDefault(formData, "widgetAlignment", "left")}
                                            options={[
                                                {value: "left", label: "Left"},
                                                {value: "center", label: "Centre"},
                                                {value: "right", label: "Right"}
                                            ]}
                                            isMulti={false}
                                            placeholder="None"
                                            className="react-select"
                                        />
                                    </div>
                                </div>

                                <div className="grid-x grid-padding-x">
                                    <div className="small-3 cell">
                                        <label htmlFor={PluginUtil.configKeys.WIDGET_SHOW_EMOTIONS}
                                               className="text-right middle">Show Emotion Selection</label>
                                    </div>
                                    <div className="large-4 small-9 cell">
                                        <label className="chkbx-container">
                                            <input
                                                className="chkbx"
                                                type="checkbox"
                                                name={PluginUtil.configKeys.WIDGET_SHOW_EMOTIONS}
                                                onChange={handleChange}
                                                checked={CommonUtil.getOrDefault(formData, PluginUtil.configKeys.WIDGET_SHOW_EMOTIONS, true)}
                                            />

                                            <span className="chkmk"></span>
                                        </label>
                                    </div>
                                </div>

                                <div className="grid-x grid-padding-x">
                                    <div className="small-3 cell">
                                        <label htmlFor={PluginUtil.configKeys.WIDGET_EMBED_TYPE} className="text-right middle">Display as Floating Widget</label>
                                    </div>
                                    <div className="large-4 small-9 cell">
                                        <label className="chkbx-container">
                                            <input
                                                className="chkbx"
                                                type="checkbox"
                                                name={PluginUtil.configKeys.WIDGET_EMBED_TYPE}
                                                onChange={handleChange}
                                                checked={parseInt(CommonUtil.getOrDefault(formData, PluginUtil.configKeys.WIDGET_EMBED_TYPE, PluginUtil.embedTypes.STATIC)) === PluginUtil.embedTypes.FLOATING}
                                            />

                                            <span className="chkmk"></span>
                                        </label>
                                    </div>
                                </div>

                                {widgetEmbedPositionElem}

                            </fieldset>
                        </div>
                    </div>

                    <div className="grid-x grid-padding-x">
                        <div className="small-12 cell">
                            <fieldset className="fieldset">
                                <legend>Content Appearance</legend>

                                <div className="grid-x grid-padding-x" style={{marginBottom: "10px"}}>
                                    <div className={"small-12 cell"}>

                                        <div className={"plugin-header-preview " + CommonUtil.getOrDefault(formData, PluginUtil.configKeys.APP_THEME, "light")}>
                                            <div
                                                className={"plugin-header-preview-container"}
                                                style={{
                                                    backgroundImage: "url(" + (appBackgroundGraphicData ?? CommonUtil.getOrDefault(formData, PluginUtil.configKeys.APP_BACKGROUND_IMAGE_URL, undefined)) + ")"
                                                }}
                                            >
                                                <div className={"plugin-header"}>
                                                    <div className={"header-action icon invert"}
                                                         style={{backgroundImage: "url(" + iconBack + ")"}}/>

                                                    <div className={"header-title"}>
                                                        {CommonUtil.getStringOrDefault(formData, "headerTitle", "Wellbeing Assistant")}
                                                    </div>

                                                    <div className={"header-action"}/>
                                                </div>

                                                <div className={"plugin-body"}>
                                                    <div className={"plugin-body-half shaded"}>
                                                        <strong>Sample Text</strong>
                                                        <div>Sample Text</div>
                                                    </div>

                                                    <div className={"plugin-body-half"}>
                                                        <strong>Sample Text</strong>
                                                        <div>Sample Text</div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>

                                <div className="grid-x grid-padding-x">
                                    <div className="small-3 cell">
                                        <label htmlFor="windowTheme" className="text-right middle">App Theme</label>
                                    </div>
                                    <div className="large-9 small-9 cell">
                                        <ReactSelect
                                            name={PluginUtil.configKeys.APP_THEME}
                                            onChange={handleChange}
                                            value={CommonUtil.getOrDefault(formData, PluginUtil.configKeys.APP_THEME, "light")}
                                            options={[
                                                {value: "light", label: "Light"},
                                                {value: "dark", label: "Dark"},
                                            ]}
                                            isMulti={false}
                                            placeholder="None"
                                            className="react-select"
                                        />
                                    </div>
                                </div>

                                <div className="grid-x grid-padding-x" style={{marginTop: "10px"}}>
                                    <div className="small-3 cell">
                                        <label htmlFor="headerTitle" className="text-right middle">Header Title</label>
                                    </div>
                                    <div className={"small-9 cell"}>
                                        <input
                                            type="text"
                                            name={PluginUtil.configKeys.HEADER_TITLE}
                                            onChange={handleChange}
                                            value={CommonUtil.getOrDefault(formData, PluginUtil.configKeys.HEADER_TITLE, "")}
                                            placeholder={"Wellbeing Assistant"}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </div>

                                <div className="grid-x grid-padding-x" style={{marginTop: "10px"}}>
                                    <div className="small-3 cell">
                                        <label htmlFor={PluginUtil.configKeys.EXPLORE_SECTION_TITLE} className="text-right middle">Explore section title</label>
                                    </div>
                                    <div className={"small-9 cell"}>
                                        <input
                                            type="text"
                                            name={PluginUtil.configKeys.EXPLORE_SECTION_TITLE}
                                            onChange={handleChange}
                                            value={CommonUtil.getOrDefault(formData, PluginUtil.configKeys.EXPLORE_SECTION_TITLE, "")}
                                            placeholder={"Explore"}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </div>

                                <ImagePickerField
                                    label={"App Background"}
                                    imageData={ appBackgroundGraphicData ?? CommonUtil.getOrDefault(formData, PluginUtil.configKeys.APP_BACKGROUND_IMAGE_URL, undefined) }
                                    callback={(action, data) => {
                                        if (action === ImagePickerFieldActions.CHANGE) {
                                            handleFilePickerChange(data, "appBackground");
                                        } else if (action === ImagePickerFieldActions.DELETE) {
                                            setAppBackgroundFile(undefined);
                                            setAppBackgroundGraphicData(undefined);

                                            const newFormData = {};
                                            newFormData[PluginUtil.configKeys.APP_BACKGROUND_IMAGE_ID] = undefined;
                                            newFormData[PluginUtil.configKeys.APP_BACKGROUND_IMAGE_URL] = undefined;
                                            putFormData(newFormData);
                                        }
                                    }}
                                />

                                <ImagePickerField
                                    label={"Chat Start Background"}
                                    imageData={ appStartBackgroundGraphicData ?? CommonUtil.getOrDefault(formData, PluginUtil.configKeys.APP_START_BACKGROUND_IMAGE_URL, undefined) }
                                    callback={(action, data) => {
                                        if (action === ImagePickerFieldActions.CHANGE) {
                                            handleFilePickerChange(data, "appStartBackground");
                                        } else if (action === ImagePickerFieldActions.DELETE) {
                                            setStartScreenImageFile(undefined);
                                            setStartScreenGraphicData(undefined);

                                            const newFormData = {};
                                            newFormData[PluginUtil.configKeys.APP_START_BACKGROUND_IMAGE_ID] = undefined;
                                            newFormData[PluginUtil.configKeys.APP_START_BACKGROUND_IMAGE_URL] = undefined;
                                            putFormData(newFormData);
                                        }
                                    }}
                                />

                                <div className={"grid-x grid-padding-x"} style={{marginTop: "10px"}}>
                                    <div className={"small-3 cell"}>
                                        <label htmlFor={PluginUtil.configKeys.FULL_SCREEN_AT_STARTUP} className={"text-right middle"}>Launch size</label>
                                    </div>
                                    <div className={"small-9 cell"}>
                                        <ReactSelect
                                            name={PluginUtil.configKeys.FULL_SCREEN_AT_STARTUP}
                                            onChange={handleChange}
                                            value={CommonUtil.getOrDefault(formData, PluginUtil.configKeys.FULL_SCREEN_AT_STARTUP, "0")}
                                            options={[
                                                {value: "0", label: "Launch normally"},
                                                {value: "1", label: "Launch in full screen"},
                                            ]}
                                            isMulti={false}
                                            placeholder="Launch normally"
                                            className="react-select"
                                        />
                                    </div>
                                </div>

                            </fieldset>
                        </div>
                    </div>

                    <div className="grid-x grid-padding-x">
                        <div className="small-12 cell">
                            <fieldset className="fieldset">
                                <legend>Start Screen</legend>

                                <ImagePickerField
                                    label={"Start Screen Image"}
                                    className={"plugin-form-image-preview-circular"}
                                    imageData={startScreenGraphicData ?? CommonUtil.getOrDefault(formData, PluginUtil.configKeys.START_SCREEN_IMAGE_URL, undefined)}
                                    callback={(action, data) => {
                                        if (action === ImagePickerFieldActions.CHANGE) {
                                            handleFilePickerChange(data, "startScreenImage");
                                        } else if (action === ImagePickerFieldActions.DELETE) {
                                            setStartScreenImageFile(undefined);
                                            setStartScreenGraphicData(undefined);

                                            const formData = {};
                                            formData[PluginUtil.configKeys.START_SCREEN_IMAGE_ID] = undefined;
                                            formData[PluginUtil.configKeys.START_SCREEN_IMAGE_URL] = undefined;
                                            putFormData(formData);
                                        }
                                    }}
                                />

                                <div className="grid-x grid-padding-x" style={{marginTop: "10px"}}>
                                    <div className="small-3 cell">
                                        <label htmlFor={PluginUtil.configKeys.START_SCREEN_TITLE_FIRST} className="text-right middle">Default Welcome Title</label>
                                    </div>
                                    <div className={"small-9 cell"}>
                                        <input
                                            type={"text"}
                                            name={PluginUtil.configKeys.START_SCREEN_TITLE_FIRST}
                                            onChange={handleChange}
                                            value={CommonUtil.getOrDefault(formData, PluginUtil.configKeys.START_SCREEN_TITLE_FIRST, "")}
                                            placeholder={"Hi There!"}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </div>

                                <div className="grid-x grid-padding-x" style={{marginTop: "10px"}}>
                                    <div className="small-3 cell">
                                        <label htmlFor={PluginUtil.configKeys.START_SCREEN_SUBTITLE_FIRST} className="text-right middle">Default Welcome Subtitle</label>
                                    </div>
                                    <div className={"small-9 cell"}>
                                        <input
                                            type={"text"}
                                            name={PluginUtil.configKeys.START_SCREEN_SUBTITLE_FIRST}
                                            onChange={handleChange}
                                            value={CommonUtil.getOrDefault(formData, PluginUtil.configKeys.START_SCREEN_SUBTITLE_FIRST, "")}
                                            placeholder={"I'm here to help"}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </div>

                                <div className="grid-x grid-padding-x" style={{marginTop: "10px"}}>
                                    <div className="small-3 cell">
                                        <label htmlFor={PluginUtil.configKeys.START_SCREEN_PROMPT_FIRST} className="text-right middle">Default Welcome Prompt</label>
                                    </div>
                                    <div className={"small-9 cell"}>
                                        <input
                                            type={"text"}
                                            name={PluginUtil.configKeys.START_SCREEN_PROMPT_FIRST}
                                            onChange={handleChange}
                                            value={CommonUtil.getOrDefault(formData, PluginUtil.configKeys.START_SCREEN_PROMPT_FIRST, "")}
                                            placeholder={"Ask me anything"}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </div>

                                <div className="grid-x grid-padding-x" style={{marginTop: "10px"}}>
                                    <div className="small-3 cell">
                                        <label htmlFor={PluginUtil.configKeys.START_SCREEN_TITLE_SECOND} className="text-right middle">Alternative Welcome Title</label>
                                    </div>
                                    <div className={"small-9 cell"}>
                                        <input
                                            type={"text"}
                                            name={PluginUtil.configKeys.START_SCREEN_TITLE_SECOND}
                                            onChange={handleChange}
                                            value={CommonUtil.getOrDefault(formData, PluginUtil.configKeys.START_SCREEN_TITLE_SECOND, "")}
                                            placeholder={"Hi There!"}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </div>

                                <div className="grid-x grid-padding-x" style={{marginTop: "10px"}}>
                                    <div className="small-3 cell">
                                        <label htmlFor={PluginUtil.configKeys.START_SCREEN_SUBTITLE_SECOND} className="text-right middle">Alternative Welcome Subtitle</label>
                                    </div>
                                    <div className={"small-9 cell"}>
                                        <input
                                            type={"text"}
                                            name={PluginUtil.configKeys.START_SCREEN_SUBTITLE_SECOND}
                                            onChange={handleChange}
                                            value={CommonUtil.getOrDefault(formData, PluginUtil.configKeys.START_SCREEN_SUBTITLE_SECOND, "")}
                                            placeholder={"I'm here to help"}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </div>

                                <div className="grid-x grid-padding-x" style={{marginTop: "10px"}}>
                                    <div className="small-3 cell">
                                        <label htmlFor={PluginUtil.configKeys.START_SCREEN_PROMPT_SECOND} className="text-right middle">Alternative Welcome Prompt</label>
                                    </div>
                                    <div className={"small-9 cell"}>
                                        <input
                                            type={"text"}
                                            name={PluginUtil.configKeys.START_SCREEN_PROMPT_SECOND}
                                            onChange={handleChange}
                                            value={CommonUtil.getOrDefault(formData, PluginUtil.configKeys.START_SCREEN_PROMPT_SECOND, "")}
                                            placeholder={"Ask me anything"}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </div>

                                {welcomeScreenChatOptions}

                            </fieldset>
                        </div>
                    </div>

                    <div className="grid-x grid-padding-x">
                        <div className="small-12 cell">
                            <fieldset className="fieldset">
                                <legend>Chat Screen</legend>

                                <ImagePickerField
                                    label={"Chat Start Image"}
                                    imageData={chatStartImageData ?? CommonUtil.getOrDefault(formData, PluginUtil.configKeys.CHAT_START_IMAGE_URL, null)}
                                    className={"plugin-form-image-preview-circular"}
                                    callback={(action, data) => {
                                        if (action === ImagePickerFieldActions.CHANGE) {
                                            handleFilePickerChange(data, "chatStartImage")
                                        } else if (action === ImagePickerFieldActions.DELETE) {
                                            setChatStartImageFile(undefined);
                                            setChatStartImageData(undefined);

                                            const formData = {};
                                            formData[PluginUtil.configKeys.CHAT_START_IMAGE_ID] = undefined;
                                            formData[PluginUtil.configKeys.CHAT_START_IMAGE_URL] = undefined;
                                            putFormData(formData);
                                        }
                                    }}
                                />

                                <div className={"grid-x grid-padding-x"} style={{marginBottom: "10px"}}>
                                    <div className={"small-12 cell"}>
                                        <PluginFormNavigationPreview data={formData}/>
                                    </div>
                                </div>

                                <div className="grid-x grid-padding-x">
                                    <div className="small-3 cell">
                                        <label htmlFor={PluginUtil.configKeys.CHAT_OPTIONS_MODE} className="text-right middle">
                                            Navigation Style
                                        </label>
                                    </div>
                                    <div className="large-9 small-9 cell">
                                        <ReactSelect
                                            name={PluginUtil.configKeys.CHAT_OPTIONS_MODE}
                                            onChange={handleChange}
                                            value={CommonUtil.getOrDefault(formData, PluginUtil.configKeys.CHAT_OPTIONS_MODE, PluginUtil.chatOptionsModes.SHOW_IN_HEADER)}
                                            options={[
                                                {value: PluginUtil.chatOptionsModes.SHOW_IN_HEADER, label: "Show in Chat Header"},
                                                {value: PluginUtil.chatOptionsModes.SHOW_IN_ASSISTANT_BUTTON, label: "Show in Assistant Options"},
                                                {value: PluginUtil.chatOptionsModes.NO_HEADER, label: "Do not show" }
                                            ]}
                                            isMulti={false}
                                            placeholder="None"
                                            className="react-select"
                                        />
                                    </div>
                                </div>

                                {headerConfigContent}

                                <div className={"grid-x grid-padding-x"}>
                                    <div className={"small-3 cell"}>
                                        <label htmlFor={PluginUtil.configKeys.POWERED_BY_ENABLED} className="text-right middle">
                                            Show Powered By
                                        </label>
                                    </div>

                                    <div className="large-4 small-9 cell">
                                        <label className="chkbx-container">
                                            <input
                                                className="chkbx"
                                                type="checkbox"
                                                name={PluginUtil.configKeys.POWERED_BY_ENABLED}
                                                onChange={handleChange}
                                                checked={CommonUtil.getOrDefault(formData, PluginUtil.configKeys.POWERED_BY_ENABLED, true)}
                                            />

                                            <span className="chkmk"></span>
                                        </label>
                                    </div>
                                </div>

                                {poweredByContent}
                            </fieldset>
                        </div>
                    </div>

                    <div className="grid-x grid-padding-x">
                        <div className="small-12 cell">
                            <fieldset className="fieldset">
                                <legend>Canvas Integration</legend>

                                <div className="grid-x grid-padding-x">
                                    <div className="small-3 cell">
                                        <label htmlFor={PluginUtil.configKeys.CANVAS_ENABLED} className="text-right middle">Enable Canvas Integration</label>
                                    </div>
                                    <div className="large-4 small-9 cell">
                                        <label className="chkbx-container">
                                            <input
                                                className="chkbx"
                                                type="checkbox"
                                                name={PluginUtil.configKeys.CANVAS_ENABLED}
                                                onChange={handleChange}
                                                checked={CommonUtil.getOrDefault(formData, PluginUtil.configKeys.CANVAS_ENABLED, false)}
                                            />
                                            <span className="chkmk"></span>
                                        </label>
                                    </div>
                                </div>

                                {CommonUtil.getOrDefault(formData, PluginUtil.configKeys.CANVAS_ENABLED, false) ? (
                                    <>
                                        <div className="grid-x grid-padding-x">
                                            <div className="small-3 cell">
                                                <label htmlFor={PluginUtil.configKeys.CANVAS_APP_NAME} className="text-right middle">Canvas App Name</label>
                                            </div>
                                            <div className="small-9 cell">
                                                <input
                                                    type="text"
                                                    name={PluginUtil.configKeys.CANVAS_APP_NAME}
                                                    onChange={handleChange}
                                                    value={CommonUtil.getOrDefault(formData, PluginUtil.configKeys.CANVAS_APP_NAME, "")}
                                                    onBlur={handleBlur}
                                                    placeholder="UniWellbeing Chatbot"
                                                />
                                            </div>
                                        </div>

                                        <div className="grid-x grid-padding-x">
                                            <div className="small-3 cell">
                                                <label htmlFor={PluginUtil.configKeys.CANVAS_DESCRIPTION} className="text-right middle">Description</label>
                                            </div>
                                            <div className="small-9 cell">
                                                <textarea
                                                    name={PluginUtil.configKeys.CANVAS_DESCRIPTION}
                                                    onChange={handleChange}
                                                    value={CommonUtil.getOrDefault(formData, PluginUtil.configKeys.CANVAS_DESCRIPTION, "")}
                                                    onBlur={handleBlur}
                                                    rows={4}
                                                />
                                            </div>
                                        </div>

                                        <ImagePickerField
                                            label={"Canvas Icon"}
                                            imageData={canvasIconData ?? getPublicAssetUrl(CommonUtil.getOrDefault(formData, PluginUtil.configKeys.CANVAS_ICON_IMAGE_URL, null))}
                                            className={"plugin-form-image-preview-circular"}
                                            callback={(action, data) => {
                                                if (action === ImagePickerFieldActions.CHANGE) {
                                                    handleFilePickerChange(data, "canvasIcon");
                                                } else if (action === ImagePickerFieldActions.DELETE) {
                                                    setCanvasIconFile(undefined);
                                                    setCanvasIconData(undefined);

                                                    const outData = {};
                                                    outData[PluginUtil.configKeys.CANVAS_ICON_IMAGE_ID] = undefined;
                                                    outData[PluginUtil.configKeys.CANVAS_ICON_IMAGE_URL] = undefined;
                                                    putFormData(outData);
                                                }
                                            }}
                                        />

                                        <div className="grid-x grid-padding-x">
                                            <div className="small-3 cell">
                                                <label htmlFor={PluginUtil.configKeys.CANVAS_PLACEMENTS} className="text-right middle">Canvas Placements</label>
                                            </div>
                                            <div className="small-9 cell">
                                                <ReactSelect
                                                    name={PluginUtil.configKeys.CANVAS_PLACEMENTS}
                                                    className="react-select"
                                                    onChange={handleChange}
                                                    value={CommonUtil.getOrDefault(formData, PluginUtil.configKeys.CANVAS_PLACEMENTS, ["course_navigation"])}
                                                    options={canvasPlacementOptions}
                                                    isMulti={true}
                                                />
                                            </div>
                                        </div>

                                        <div className="grid-x grid-padding-x">
                                            <div className="small-3 cell">
                                                <label htmlFor={PluginUtil.configKeys.CANVAS_OPEN_IN_NEW_TAB} className="text-right middle">Open in new tab</label>
                                            </div>
                                            <div className="large-4 small-9 cell">
                                                <label className="chkbx-container">
                                                    <input
                                                        className="chkbx"
                                                        type="checkbox"
                                                        name={PluginUtil.configKeys.CANVAS_OPEN_IN_NEW_TAB}
                                                        onChange={handleChange}
                                                        checked={CommonUtil.getOrDefault(formData, PluginUtil.configKeys.CANVAS_OPEN_IN_NEW_TAB, false)}
                                                    />
                                                    <span className="chkmk"></span>
                                                </label>
                                            </div>
                                        </div>

                                        <div className="grid-x grid-padding-x">
                                            <div className="small-3 cell"/>
                                            <div className="small-9 cell">
                                                <div className="btn-wrap">
                                                    <button type="button" className="button secondary" onClick={canvasInstructionsWasRequested}>
                                                        Show Canvas Instructions
                                                    </button>
                                                    <button type="button" className="button" onClick={canvasLtiJsonWasRequested} disabled={isLoadingLtiConfig}>
                                                        Show LTI JSON config
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="grid-x grid-padding-x">
                                            <div className="small-12 cell">
                                                <hr style={{margin: "1rem 0"}} />
                                            </div>
                                        </div>

                                        <div className="grid-x grid-padding-x">
                                            <div className="small-12 cell">
                                                <h6 style={{marginBottom: "0.25rem"}}>LTI Platform Details</h6>
                                                <p style={{marginBottom: "0.75rem", fontSize: "0.85rem"}}>Provide Canvas platform values from your Developer Key / app setup.</p>
                                            </div>
                                        </div>

                                        <div className="grid-x grid-padding-x">
                                            <div className="small-3 cell">
                                                <label htmlFor={PluginUtil.configKeys.CANVAS_LTI_ISSUER} className="text-right middle">Issuer</label>
                                            </div>
                                            <div className="small-9 cell">
                                                <input
                                                    type="text"
                                                    name={PluginUtil.configKeys.CANVAS_LTI_ISSUER}
                                                    onChange={handleChange}
                                                    value={CommonUtil.getOrDefault(formData, PluginUtil.configKeys.CANVAS_LTI_ISSUER, "")}
                                                    onBlur={handleBlur}
                                                    placeholder="https://canvas.domain"
                                                />
                                            </div>
                                        </div>

                                        <div className="grid-x grid-padding-x">
                                            <div className="small-3 cell">
                                                <label htmlFor={PluginUtil.configKeys.CANVAS_LTI_CLIENT_ID} className="text-right middle">Client ID</label>
                                            </div>
                                            <div className="small-9 cell">
                                                <input
                                                    type="text"
                                                    name={PluginUtil.configKeys.CANVAS_LTI_CLIENT_ID}
                                                    onChange={handleChange}
                                                    value={CommonUtil.getOrDefault(formData, PluginUtil.configKeys.CANVAS_LTI_CLIENT_ID, "")}
                                                    onBlur={handleBlur}
                                                />
                                            </div>
                                        </div>

                                        <div className="grid-x grid-padding-x">
                                            <div className="small-3 cell">
                                                <label htmlFor={PluginUtil.configKeys.CANVAS_LTI_DEPLOYMENT_ID} className="text-right middle">Deployment ID</label>
                                            </div>
                                            <div className="small-9 cell">
                                                <input
                                                    type="text"
                                                    name={PluginUtil.configKeys.CANVAS_LTI_DEPLOYMENT_ID}
                                                    onChange={handleChange}
                                                    value={CommonUtil.getOrDefault(formData, PluginUtil.configKeys.CANVAS_LTI_DEPLOYMENT_ID, "")}
                                                    onBlur={handleBlur}
                                                />
                                            </div>
                                        </div>

                                        <div className="grid-x grid-padding-x">
                                            <div className="small-3 cell">
                                                <label htmlFor={PluginUtil.configKeys.CANVAS_LTI_JWKS_URI} className="text-right middle">JWKS URI</label>
                                            </div>
                                            <div className="small-9 cell">
                                                <input
                                                    type="text"
                                                    name={PluginUtil.configKeys.CANVAS_LTI_JWKS_URI}
                                                    onChange={handleChange}
                                                    value={CommonUtil.getOrDefault(formData, PluginUtil.configKeys.CANVAS_LTI_JWKS_URI, "")}
                                                    onBlur={handleBlur}
                                                    placeholder="https://canvas.domain/api/lti/security/jwks"
                                                />
                                            </div>
                                        </div>

                                        <div className="grid-x grid-padding-x">
                                            <div className="small-3 cell">
                                                <label htmlFor={PluginUtil.configKeys.CANVAS_LTI_AUTH_LOGIN_URI} className="text-right middle">Auth Login URI</label>
                                            </div>
                                            <div className="small-9 cell">
                                                <input
                                                    type="text"
                                                    name={PluginUtil.configKeys.CANVAS_LTI_AUTH_LOGIN_URI}
                                                    onChange={handleChange}
                                                    value={CommonUtil.getOrDefault(formData, PluginUtil.configKeys.CANVAS_LTI_AUTH_LOGIN_URI, "")}
                                                    onBlur={handleBlur}
                                                    placeholder="https://canvas.domain/api/lti/authorize_redirect"
                                                />
                                            </div>
                                        </div>

                                        <div className="grid-x grid-padding-x">
                                            <div className="small-3 cell">
                                                <label htmlFor={PluginUtil.configKeys.CANVAS_LTI_TOKEN_URI} className="text-right middle">Token URI</label>
                                            </div>
                                            <div className="small-9 cell">
                                                <input
                                                    type="text"
                                                    name={PluginUtil.configKeys.CANVAS_LTI_TOKEN_URI}
                                                    onChange={handleChange}
                                                    value={CommonUtil.getOrDefault(formData, PluginUtil.configKeys.CANVAS_LTI_TOKEN_URI, "")}
                                                    onBlur={handleBlur}
                                                    placeholder="Optional"
                                                />
                                            </div>
                                        </div>
                                    </>
                                ) : null}
                            </fieldset>
                        </div>
                    </div>

                    <div className="grid-x grid-padding-x">
                        <div className="small-12 cell">
                            <fieldset className="fieldset">
                                <legend>Notifications</legend>
                                By default, all notifications will be sent through UniWellbeing accounts using APNS (Apple) and FCM (Google). You can change this to another provider.
                                <div className="grid-x grid-padding-x">
                                    <div className="small-3 cell">
                                        <label htmlFor="notificationConfigID" className="text-right middle">Config</label>
                                    </div>
                                    <div className={"small-9 cell " + (CommonUtil.getOrDefault(errors, "notificationConfigID", null) && "error")}>
                                        <ReactSelect
                                            name="notificationConfigID"
                                            className="react-select"
                                            onChange={handleChange}
                                            value={CommonUtil.getOrDefault(formData, "notificationConfigID", null)}
                                            options={notifConfigOptions}
                                            onBlur={handleBlur}
                                            isClearable={true}
                                        />
                                        <small className="error">{CommonUtil.getOrDefault(errors, "notificationConfigID", "")}</small>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>

                    <div className="grid-x grid-padding-x">
                        <div className="small-12 cell">
                            <fieldset className="fieldset">
                                <legend>How to integrate</legend>

                                {integrationExplainElem}

                            </fieldset>
                        </div>
                    </div>

                </div>

                <div className="modal-footer">
                    <div className="grid-x grid-padding-x">
                        <div className="small-12 cell">
                            <div className="btn-wrap">
                                {
                                    <React.Fragment>
                                        <button
                                            className="button secondary"
                                            type="button"
                                            onClick={() => handleCallback("submit")}
                                        >
                                            Cancel
                                        </button>

                                        <button
                                            className="button success"
                                            type="submit"
                                            disabled={!validateForm()}
                                        >
                                            Submit
                                        </button>
                                    </React.Fragment>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </form>

            <Modal
                classNames={{modal: "modal-medium"}}
                open={modalOpen}
                modalId="PluginModal"
                onClose={pluginModalDidDismiss}
                center
            >
                {modalContent}
            </Modal>
        </>
    )

}

const ImagePickerFieldActions = {
    CHANGE : "imagePickerField.Change",
    DELETE : "imagePickerField.Delete"
}

const ImagePickerField = (props) => {

    const {className} = props;
    const {label} = props;
    const {removeLabel} = props;
    const {imagePlaceholder} = props;
    const {imageData} = props;
    const {callback} = props;

    function handleCallback(action, data) {
        if (callback) {
            callback(action, data);
        }
    }

    // let welcomeScreenGraphicRemoveButton = [];
    // if (imageData) {
    //     welcomeScreenGraphicRemoveButton = (
    //         <button className={"button danger"} onClick={(e) => {
    //             e.stopPropagation();
    //             e.preventDefault();
    //
    //             handleCallback(
    //                 ImagePickerFieldActions.DELETE
    //             );
    //
    //             // const newData = {};
    //             // newData[PluginUtil.configKeys.APP_BACKGROUND_IMAGE_ID] = undefined;
    //             // newData[PluginUtil.configKeys.APP_BACKGROUND_IMAGE_URL] = undefined;
    //             // putFormData(newData);
    //         }}>
    //             {removeLabel ?? "Remove"}
    //         </button>
    //     );
    // }

    return(
        <div className="grid-x grid-padding-x">
            <div className="small-3 cell">
                <label htmlFor="imageFile" className="text-right middle">{label}</label>
            </div>
            <div className="large-9 small-9 cell ">
                <div
                    className={"plugin-form-image-preview " + (className ?? "")}
                    style={{
                        marginBottom: "10px",
                        backgroundImage: "url(" + imageData + ")"
                    }}
                />

                <FileInput
                    name="file"
                    onChange={(e) => handleCallback(ImagePickerFieldActions.CHANGE, e)}
                    onDelete={() => handleCallback(ImagePickerFieldActions.DELETE)}
                    placeholder={imagePlaceholder ?? "Not selected."}
                    accept="image/jpeg,image/jpg,image/png,image/svg,image/svg+xml"
                />

            </div>
        </div>
    )
    //{welcomeScreenGraphicRemoveButton}
    // handleFilePickerChange(e, "welcome") handleFileDelete("welcome")

}
